import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import GlobalStore from "stores/globalStore";
import FreePremium from "components/user/dashboard/FreePremium";
import QR from "../../../assets/img/open-app-qr.jpg";
import "./profileUser.css";
import { formatDate } from "utils/helpers";
import { useGetUserProfileApi } from "./useUserApi";
import { Row } from "antd";
import Loading from "components/Loading/Loading";

const ProfileUser: React.FC = () => {
  const { profileObject, isLoading } = useGetUserProfileApi();
  const { t } = useTranslation();
  const { entitlements } = GlobalStore.useContainer();
  const isProLifetime = entitlements?.tier?.code !== "free" && !entitlements?.tier?.expire_at;
  const isConversationBundle = entitlements?.transactions ? entitlements.transactions.filter((item) => item.catalog === "ai_role_play_sa") : [];
  const isNova = profileObject?.data?.nova_mode;

  return (
    <div className="dashboard-package-container">
      <Helmet>
        <title>User Account - ELSA Speak</title>
        <meta name="description" content="ELSA Speak App user account login for web PC. Redeem promo code ELSA Speak Pro, ELSA Oxford Business Result, ELSA for Students, ELSA Speak free." />
      </Helmet>
      <h2>{t("homepage.page_title")}</h2>
      {isLoading ? (
        <Row justify="center">
          <Loading color="#ccc" />
        </Row>
      ) : (
        <article className="dashboard-profile-container">
          <section className="dashboard-package">
            {entitlements?.tier?.code !== "free" && (
              <div className="card-package">
                <div className="card-package__panel">
                  <div className="card-package-header">
                    {entitlements?.tier && (
                      <div className="card-package-header-name">
                        <span className="card-package-header-title">目前套餐: ELSA {entitlements?.tier?.code[0].toUpperCase() + entitlements?.tier?.code.slice(1)}</span>
                        <div className="features">
                          {isProLifetime ? (
                            <>
                              {t("packages.using_unlimited")}
                              {isConversationBundle.length ? <p>{t("and")} Conversation Bundle: ELSA AI & Speech Analyzer</p> : ""}
                            </>
                          ) : (
                            <p>
                              到期日:
                              <strong>{" " + formatDate(new Date(entitlements?.tier.expire_at * 1000))}</strong>
                            </p>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            {entitlements?.tier?.code !== "premium" || !isNova ? (
              <FreePremium isNova={isNova} tier={entitlements?.tier?.code} />
            ) : (
              <div className="qr-code">
                <p>掃描二維碼進入應用程序並立即開始練習！</p>
                <img src={QR} alt="" width={240} />
              </div>
            )}
          </section>
        </article>
      )}
    </div>
  );
};

export default ProfileUser;
